var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50008 0.791504C4.69071 0.791504 0.791748 4.69046 0.791748 9.49984C0.791748 14.3092 4.69071 18.2082 9.50008 18.2082C14.3095 18.2082 18.2084 14.3092 18.2084 9.49984C18.2084 4.69046 14.3095 0.791504 9.50008 0.791504ZM13.2747 8.02734C13.3443 7.94789 13.3972 7.85534 13.4304 7.75514C13.4636 7.65493 13.4764 7.5491 13.4681 7.44387C13.4598 7.33863 13.4306 7.23612 13.3821 7.14235C13.3336 7.04859 13.2668 6.96548 13.1857 6.8979C13.1046 6.83032 13.0108 6.77964 12.9099 6.74884C12.8089 6.71805 12.7028 6.70776 12.5978 6.71858C12.4928 6.72939 12.391 6.7611 12.2984 6.81184C12.2059 6.86257 12.1244 6.93131 12.0587 7.014L8.65458 11.0982L6.89312 9.33596C6.74381 9.19175 6.54384 9.11196 6.33626 9.11376C6.12869 9.11557 5.93013 9.19882 5.78335 9.34561C5.63657 9.49239 5.55331 9.69095 5.55151 9.89852C5.5497 10.1061 5.6295 10.3061 5.77371 10.4554L8.14871 12.8304C8.22649 12.9081 8.31962 12.9688 8.42216 13.0086C8.5247 13.0483 8.63439 13.0663 8.74425 13.0613C8.85411 13.0563 8.96173 13.0285 9.06024 12.9796C9.15875 12.9307 9.246 12.8618 9.31641 12.7773L13.2747 8.02734Z",
    fill: "#6AA287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.42ecef0717828d19b77fb815ef9d03be.svg";
export { ForwardRef as ReactComponent };